// extracted by mini-css-extract-plugin
export var compactFilters = "_ik-4";
export var detailImage = "_ik-1";
export var dropdownContainer = "_ik-2";
export var imageContainer = "_ik-0";
export var selectedCard = "_ik-3";